(() => {
  function gbi(id) {
    return document.getElementById(id);
  }
  function qsa(sel) {
    return document.querySelectorAll(sel);
  }
  function html(id, htm) {
    gbi(id).innerHTML = htm;
  }
  function show(id, typ) {
    gbi(id).style.display = typ || 'block';
  }
  function hide(id) {
    gbi(id).style.display = 'none';
  }

  function removehili() {
    var a = qsa('.selwd');
    var i,
      n = a.length;
    if (n > 0) {
      for (i = 0; i < n; i++) {
        a[i].classList.remove('selwd');
      }
    }
    return n === 0;
  }

  function hidexbox() {
    removehili();
    hide('xbox');
  }

  function selchange(e) {
    // event handler for clicks/taps on the 'roots' checkbox to turn it on/off
    var id, a, d, i, n, y;
    id = e.target.id;
    d = id.slice(8); // get id of the containing div, eg 'exp2-4'
    if (/^chkroot-/.test(id)) {
      y = gbi(id).checked;
      a = gbi(d).querySelectorAll('.w'); // nb ignore any with class=wpers
      n = a.length;
      for (i = 0; i < n; i++) {
        d = gbi(a[i].id);
        if (d.dataset.root) {
          if (y) {
            d.classList.add('ulin');
          } else {
            d.classList.remove('ulin');
          }
        }
      }
    }
  }

  function klap(e) {
    // event handler for clicks/taps on elements in the story explorers and interactive images
    var a, b, c, d, i, id, m, n, r, s, t, x, y;

    t = e.target;
    id = t.id;
    if (!id) {
      if (t.parentElement) {
        id = t.parentElement.id;
        if (!id) {
          if (t.parentElement) {
            id = t.parentElement.parentElement.id;
          }
        }
      }
    }
    if (id === 'xbox') {
      hidexbox();
    } else if (id === 'caption-map') {
      hide('caption-map');
    } else if (/^w\d+/.test(id)) {
      n = id.slice(1).replace(/-\d+$/, '');
      r = gbi(`chkroot-exp${n}`);
      a = qsa('.selwd');
      for (i = 0, m = a.length; i < m; i++) {
        // remove highlighting from all words currently highlit
        a[i].classList.remove('selwd');
      }
      b = t.dataset.prs.split('^');
      s = `<span class=lathwd>${b[1].replace(/%.+/, '')}</span>   ${b[2].replace(/%.+/, '')}`;
      if (b.length > 3) {
        // there are notes on linked words
        c = b[3].split('+');
        s += `<br>    <span class=phrase>${c[1]}</span>   ${c[2]}`;
        d = c[0].split(',');
        for (i = 0, m = d.length; i < m; i++) {
          x = `w${n}-${d[i]}`;
          y = gbi(x);
          y.classList.add('selwd');
        }
      }
      if (r?.checked) {
        // only show roots if 'roots' checkbox exists and is ticked
        d = t.dataset.root;
        if (d) {
          d = roots[d];
          d = d.replace(/\{/g, '\u2192\u2000<span class=rootlang>');
          d = d.replace(/\}/g, '</span>');
          s += `<div class=deriv>${d}</div>`;
        }
      }
      show('xbox', 'block');
      //		html('xbox', s);
      html('xbox', `<div id=xboxtxt style="width:40rem;margin:0 auto">${s}</div>`);
      t.classList.add('selwd'); // add highlight to newly clicked word
    } else if (/^wi\d+/.test(id)) {
      n = id.slice(2).replace(/-\d+$/, '');
      a = qsa('.selwd');
      for (i = 0, m = a.length; i < m; i++) {
        // remove highlighting from all words currently highlit
        a[i].classList.remove('selwd');
      }
      s = t.dataset.prs;
      show('xbox', 'block');
      //		html('xbox', s);
      html('xbox', `<div id=xboxtxt style="width:40rem;margin:0 auto">${s}</div>`);
      t.classList.add('selwd'); // add highlight to newly clicked word
    } else {
      hidexbox();
      if (/^pop-/.test(id)) {
        s = id.replace(/-\d+$/, '');
        s = s.replace(/^pop/, 'caption');
        d = gbi(s).style.display;
        if (d === '' || d === 'none') {
          html(s, t.dataset.cap);
          show(s);
          gbi(s).style.top = t.dataset.topoff;
        } else {
          hide(s);
        }
      } else if (/^caption-/.test(id)) {
        id = id.replace(/-\d+$/, ''); // strip uniquifying '-' + number from end of id
        hide(id);
      }
    }
  }

  document.addEventListener('click', klap, false);
  document.addEventListener('change', selchange, false);
})();
